import React, { useState, useRef, useEffect } from 'react';
import { Typography, Tooltip } from '@mui/material';

const WidgetHeader = ({ title, icon: Icon, sx: sxProp }) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const isOverflowing =
        textRef.current.scrollWidth > textRef.current.clientWidth;
      setIsOverflowed(isOverflowing);
    }
  }, [title]); // Re-check when title changes

  return (
    <Typography
      padding='10px'
      variant='h3'
      sx={{
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        ...sxProp,
      }}
    >
      {Icon && <Icon style={{ marginRight: '8px' }} />}
      <Tooltip title={title} arrow disableHoverListener={!isOverflowed}>
        <span
          ref={textRef}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
          }}
        >
          {title}
        </span>
      </Tooltip>
    </Typography>
  );
};

export default WidgetHeader;
